export default __webpack_public_path__ + "static/media/power6.681a5ce2.svg";